export const plantillasHcRoutes = [
  {
    path: '/plantillas-hc',
    name: 'PlantillasHCIndex',
    desplegable: false,
    icon: 'mdiNoteTextOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      permiso: [],
      perfiles: [
        'VACUNACION',
        'CONSULTA EXTERNA',
        'PROCEDIMIENTOS',
        'LABORATORIOS',
        'COORDINADOR ASISTENCIAL',
        'OTROS SERVICIOS'
      ],
      title: 'Plantillas HC',
      subTitle: 'Preconfiguración de campos',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/PlantillasHC/views/PlantillasHCIndex.vue'
      )
  },
  {
    path: '/plantillas-hc/create',
    name: 'PlantillasHCCreate',
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/PlantillasHC/views/PlantillasHCForm.vue'
      ),
    icon: '',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Crear Plantilla HC',
      requiresSession: true,
      permiso: []
    },
    children: []
  },
  {
    path: '/plantillas-hc/create/:id',
    name: 'PlantillasHCUpdate',
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/PlantillasHC/views/PlantillasHCForm.vue'
      ),
    icon: '',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Editar Plantilla HC',
      requiresSession: true,
      permiso: []
    },
    children: []
  }
]
